import { useSelector } from "react-redux"

import { CToast } from "../../views/addons/ToastMessage"
import { serverRequest } from "../helpers/Axios/serverRequest"
import { validatePassword } from "../helpers/validatePassword"
import { useRedirect } from "./useRedirect"
import { handleCleanForm } from "../../redux/actions/form"
import { useErrorHandler } from "./errorHandler/useErrorHandler"

export const useSubmit = (endPoint, id = null, callback) => {
    const redirect = useRedirect(id)
    const { form } = useSelector(state => state)
    const err = useErrorHandler(endPoint)

    const thenRedirection = (res) => {
        dispatch(handleCleanForm())
        CToast({ title: '¡Guardado!', message: 'Se ha guardado la información correctamente.' }, 'success')
        redirect.redirectToEdit(res)
    }

    const submitAndStay = () => {
        console.log(form, 'flag')
        serverRequest(endPoint, id, { ...form }, 'POST').then(res => {
            if (res?.hasErrors) err.errorHandler(res.errorList)
            else if (!!res) thenRedirection(res)
        })

    }

    const submit = submitAndStay

    const passwordValidation = () => {
        const validation = validatePassword(form.password, form.confirmPassword, id)
        if (!validation.status) {
            CToast({ title: '¡Error!', message: validation.msg })
            return
        }
        delete form.confirmPassword
        submit()
    }

    const submitAndStaySale = async () => {
        console.log(form, 'sale - flag')
        const { files, ...sale } = form
        await submitFiles(files, 'saleFile')
        serverRequest(endPoint, id, sale, 'POST').then(res => {
            if (!!res) {
                CToast({ title: '¡Guardado!', message: 'Se ha guardado la información correctamente.' }, 'success')
                redirect.redirectToEdit(res)
            }
        })
    }

    const submitFiles = async (files = [], fileEndPoint) => {
        if (files.length !== 0) {
            for (const file of files) {
                const formData = new FormData()
                formData.append('file', file)
                formData.append('dest', endPoint)
                await serverRequest(fileEndPoint, id, formData, 'FILEUPLOAD')
            }
        }
    }

    const serializeDocs = async (documents) => {
        const serializedDocs = []
        for (let index = 0; index < documents.length; index++) {
            const document = documents[index].binary.blobData;
            const blob = await fetch(document).then(d => d.blob());
            serializedDocs.push({ ...documents[index], binary: { ...documents[index].binary, blobData: blob } })
        }
        return serializedDocs
    }

    return { submit, submitAndStay, passwordValidation, submitAndStaySale }
}
